import React  from "react";
import Modal from 'react-bootstrap/Modal';

const ModalHeader = (props) => {

    const { title } = props
    return (
        <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
    )
}

export default ModalHeader;